import React from 'react';

type Args = {
    /** MUST BE MEMOIZED */
    onOnline?: () => void;
    /** MUST BE MEMOIZED */
    onOffline?: () => void;
};

/**
 * @param options - various options the hook accepts
 * @param options.onOnline - YOU MUST MEMOIZE: callback function
 * @param options.onOffline - YOU MUST MEMOIZE: callback function
 * @returns boolean
 */
function useIsOnline({ onOnline, onOffline }: Args = {}) {
    const [isOnline, setIsOnline] = React.useState(true);

    React.useEffect(() => {
        const onlineListener = () => {
            setIsOnline(true);
            onOnline?.();
        };

        const offlineListener = () => {
            setIsOnline(false);
            onOffline?.();
        };
        window.addEventListener('online', onlineListener);
        window.addEventListener('offline', offlineListener);

        return () => {
            window.removeEventListener('online', onlineListener);
            window.removeEventListener('offline', offlineListener);
        };
    }, [onOnline, onOffline]);

    return isOnline;
}

export default useIsOnline;
